module.exports = window["wc"]["blockTemplates"];